import GeneralModal from './GeneralModal'
import Modal from 'react-modal'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import { useSubscriptionQuery } from '../../api/api'
import LoadingBlocker from '../LoadingSpinner/LoadingBlocker'
import dayjs from 'dayjs'

const PaymentConfirmModal = ({ isOpen, onRequestClose }) => {
  const { data: subscription, isLoading: subscriptionIsLoading } =
    useSubscriptionQuery()
  const nextBillDate = dayjs.unix(subscription?.nextBillDate)

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal w-[750px]"
      overlayClassName="modal-overlay"
    >
      <div className="p-12 rounded-t relative min-h-[300px]">
        {subscriptionIsLoading ? (
          <LoadingBlocker />
        ) : (
          <>
            <div className="text-lg text-white-dark font-body font-semibold mb-1">
              Welcome to the{' '}
            </div>
            <div className="font-heading font-bold text-salmon text-5xl">
              Sharefolio Paid Plan
            </div>
            <div className="mt-8">
              <p className="mb-1">
                Thank you for your purchase, your subscription will renew on:{' '}
                {nextBillDate.format('dddd, MMMM D, YYYY')}
              </p>
              <p className="mb-2">Enjoy the following Paid Plan perks:</p>
              <ul className="text-sm font-bold">
                <li className="mb-1 flex items-center">
                  <Notch />
                  Unlimited Track Uploads
                </li>
                <li className="mb-1 flex items-center">
                  <Notch />
                  Unlimited Web Players
                </li>
                <li className="mb-1 flex items-center">
                  <Notch />
                  Unlimited Portfolios
                </li>
                <li className=" flex items-center">
                  <Notch />
                  Removed Branding from Web Players
                </li>
              </ul>
            </div>
            <div className=" mt-12">
              <button
                className="button w-full bg-purple-light hover:bg-purple-light-med"
                onClick={onRequestClose}
              >
                Continue
              </button>
            </div>

            <button
              className="p-4 absolute top-0 right-0"
              onClick={onRequestClose}
            >
              <CloseIcon fill="#CCC" />
            </button>
          </>
        )}
      </div>
    </Modal>
  )
}

const Notch = () => (
  <span className="inline-block mr-2 bg-white-dark rounded-full h-[5px] w-[5px]"></span>
)

export default PaymentConfirmModal
